const planningColors = {
  "FERIES": "#FAE8D7",
  "VACANCES": "#DBFAD8",
  "ENTREPRISE": "#E9D5FB",
  "FORMATION": "#C0D9FF",
};

export const planningColorsText = {
  "FERIES": "#FA8100",
  "VACANCES": "#008000",
  "ENTREPRISE": "#8631D6",
  "FORMATION": "#0060F9",
};

export function darkenColor(hex, percent) {
  // Enlever le symbole '#' si présent
  hex = hex.replace("#", "");

  // Convertir la couleur hexadécimale en valeurs RVB
  let r = parseInt(hex.substring(0, 2), 16);
  let g = parseInt(hex.substring(2, 4), 16);
  let b = parseInt(hex.substring(4, 6), 16);

  // Calculer les nouvelles valeurs RVB en réduisant chaque composante
  r = Math.max(0, Math.min(255, r - (r * percent) / 100));
  g = Math.max(0, Math.min(255, g - (g * percent) / 100));
  b = Math.max(0, Math.min(255, b - (b * percent) / 100));



  // Reconvertir les valeurs RVB en hexadécimal
  r = Math.round(r).toString(16).padStart(2, "0");
  g = Math.round(g).toString(16).padStart(2, "0");
  b = Math.round(b).toString(16).padStart(2, "0");

  // Retourner la couleur assombrie
  return `#${r}${g}${b}`;
}


export default planningColors;